import './App.css';
import Controller from "./components/Controller/Controller";
import Error from "./components/err404/err404";
import { BrowserRouter, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <BrowserRouter>
      {/* <Controller /> */}

      <Routes>
        <Route path="/player1" element={<Controller />} />
        <Route path="/player2" element={<Controller />} />
        <Route path="/player3" element={<Controller />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
